import { useNavigate } from "react-router-dom";
import { trackingService } from "@/lib/tracking";
import { BotMessage } from "../../components/BotMessage";
import { QuickReplies } from "../../components/QuickReplies";
import { ChatTurnLayout } from "../../components/ChatTurnLayout";
import type { ChatTurnProps } from "../../types/chat";

const OPEN_SCREEN = "open-screen";

// A step answered on its own screen: the bot asks, a conversation action
// opens the screen.
export function ScreenStepTurn({
  scenario,
  step,
  isPromptTyped,
  facts,
}: ChatTurnProps) {
  const navigate = useNavigate();

  return (
    <ChatTurnLayout
      thread={
        <BotMessage lines={step.copy.prompt(facts)} isTyped={isPromptTyped} />
      }
      actions={
        <QuickReplies
          replies={[{ id: OPEN_SCREEN, label: `${step.copy.cta(facts)} →` }]}
          onSelect={() => {
            void trackingService.trackEvent("chat_step_continue", {
              step_id: step.id,
              scenario_id: scenario.id,
            });
            navigate(step.screen.entry(facts));
          }}
        />
      }
    />
  );
}
